// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1dZm1","title":"FrontImage_title__2bTce"};